import React from "react";
import cx from "classnames";
import { animated, useSpring } from "@react-spring/web";
import useMeasure from "react-use-measure";

import styles from "./common.module.scss";

interface AnimatedHeightProps {
  className?: string;
  /** Floor height while animating (e.g. table min-height). */
  minHeight?: number;
  children: React.ReactNode;
}

/** Smoothly animates height when children grow or shrink (react-spring + measure). */
export const AnimatedHeight: React.FC<AnimatedHeightProps> = ({
  className,
  minHeight = 0,
  children,
}) => {
  const [ref, bounds] = useMeasure();
  const targetHeight = Math.max(bounds.height, minHeight);

  const { height } = useSpring({
    height: targetHeight,
    config: { tension: 280, friction: 28 },
  });

  return (
    <animated.div
      className={cx(styles.animatedHeight, className)}
      style={{ height, overflow: "hidden" }}
    >
      <div ref={ref} className={styles.animatedHeightInner} style={{ minHeight }}>
        {children}
      </div>
    </animated.div>
  );
};
